import Skeleton from "./Skeleton"

export default function ProfileLoading({}) {
  return (
    <div className="flex flex-1 flex-col px-4">
      <Skeleton w={180} h={36} style="my-3" />
      <Skeleton h={142} />
      <Skeleton w={200} h={36} style="my-3" />
      <Skeleton h={210} />
    </div>
  )
}
